"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const shareExperience_1 = __importDefault(require("../shareExperience/shareExperience"));
const screenConstants_1 = require("../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const messageCard_1 = __importDefault(require("./messageCard"));
const HomeWarningCards = ({ warnings, children, activeLoan, npsSurvey, submittedRating, ongoingLoanApplication, }) => {
    const navigation = (0, useAppNavigation_1.default)();
    let warningMessages = [];
    let applicationMessages = [];
    let informationMessages = [];
    let shareExperience = [];
    let customUrlWarningMessages = [];
    if (warnings) {
        if (warnings.warning_status) {
            warningMessages = warnings.warning_status.map((warning) => (react_1.default.createElement(messageCard_1.default, { key: warning.message, warning: warning })));
        }
        if (warnings.application_status) {
            applicationMessages = warnings.application_status.map((warning) => (react_1.default.createElement(messageCard_1.default, { key: warning.message, warning: warning, onPress: () => navigation.navigate(screenConstants_1.LOAN_APPLICATION_SUMMARY_SCREEN), isInformation: true })));
        }
        if (warnings.information_status) {
            informationMessages = warnings.information_status.map((warning) => (react_1.default.createElement(messageCard_1.default, { key: warning.message, warning: warning, isInformation: true })));
        }
        if (warnings.custom_url_status) {
            customUrlWarningMessages = warnings.custom_url_status.map((warning) => (react_1.default.createElement(messageCard_1.default, { key: warning.message, warning: warning, isCustomUrl: true })));
        }
    }
    // share your experience card
    shareExperience = (react_1.default.createElement(shareExperience_1.default, { activeLoan: activeLoan, ongoingLoanApplication: ongoingLoanApplication, submittedRating: submittedRating, nps_survey: npsSurvey }));
    return (react_1.default.createElement(react_native_1.View, null,
        warningMessages,
        customUrlWarningMessages,
        applicationMessages,
        children,
        informationMessages,
        shareExperience));
};
exports.default = HomeWarningCards;
